import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 62AD0407-3DB5-48B0-8A26-3C5A07C78582
 * name calendar-check-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-check-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarCheckOutlineIcon = createSvgIcon(<><path d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H19C20.11 21 21 20.11 21 19V5C21 3.9 20.11 3 19 3M19 19H5V9H19V19M5 7V5H19V7H5M10.56 17.46L16.5 11.53L15.43 10.47L10.56 15.34L8.45 13.23L7.39 14.29L10.56 17.46Z" /></>, 'CalendarCheckOutlineIcon');
export default CalendarCheckOutlineIcon